import { Component, OnInit, ViewChild, ElementRef,
    Input, Output, EventEmitter } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { VcaAlertsService } from '../../../../../common/vca-alerts';
import {VcaGrid} from '../../../../../common/vca-grid/vca-grid.component';
import { NgForm } from '@angular/forms';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { DcService } from '../dc.service';

import { Response } from '@angular/http';
const _ = require('lodash');
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';

@Component({
    selector: 'add-edit-deployment-container-dialog',
    template: require('./add-edit-dc.html'),
    styles: [require('../dc.scss')],
    providers: [
        TranslateService, DcService
      ]
})


export class AddEditDeploymentContainerDialog {
    @Input() isDialogOpen: boolean;
    @Input() isEdit: boolean = false;
    @Input() editData: any;
    @Input() vcList: Array<Object>;
    @Input() isGlobalDeploymentContainer: boolean = false;
    @Input() globalDeploymentContainerVc: string = '';

    @Output('cancel') cancelEventEmitter = new EventEmitter();
    @Output('save') saveEventEmitter = new EventEmitter();

    private isEntityDialogVisible: boolean = false;
    private entityType: string = '';
    private selectedVc: string;
    private nodeToBeSelectedOnLoad: string;
    private isRPDialogVisible: boolean = false;
    private isDSDialogVisible: boolean = false;
    private isFolderDialogVisible: boolean = false;
    private isLoading: boolean = false;
    private isEditInProgress: boolean = false;
    private isReadOnly: boolean = true;
    private dialogAction: string = 'Add';
    private disableGlobal: boolean = false;

    private dataModel = {
        deploymentContainerName: '',
        id: '',
        vCId: '',
        isGlobal: false,
        resourcePool: {
            name: '',
            id: ''
        },
        datastore: {
            name: '',
            id: ''
        },
        folder: {
            name: '',
            id: ''
        },
        storage: ''
    }

    constructor(private router: Router,
                private alert: VcaAlertsService,
                private activatedRoute: ActivatedRoute,
                private translate: TranslateService,
                private service: DcService) {

        translate.use(GlobalVariables.LOCALE);
        this.resetData();
    }


    private resetData() {
        this.dataModel = {
            deploymentContainerName: '',
            id: '',
            vCId: '',
            isGlobal: false,
            resourcePool: {
                name: '',
                id: ''
            },
            datastore: {
                name: '',
                id: ''
            },
            folder: {
                name: '',
                id: ''
            },
            storage: ''
        }
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.disableGlobal = this.isGlobalDeploymentContainer;
        this.resetData();
        this.selectedVc = 'select';
        if (this.isEdit && this.editData) {
            let dm = this.dataModel;
            let ed = this.editData;
            dm.deploymentContainerName = ed.name;
            dm.id = ed.id;
            dm.isGlobal = (typeof ed.isGlobal !== "undefined") ? ed.isGlobal : false;
            this.disableGlobal = dm.isGlobal ? false : this.isGlobalDeploymentContainer;
            if (ed.resourcePoolsInfo && ed.resourcePoolsInfo.length > 0) {
                dm.resourcePool.name = ed.resourcePoolsInfo[0].name;
                dm.resourcePool.id = ed.resourcePools[0];
            }

            if (ed.datastoresInfo && ed.datastoresInfo.length > 0) {
                dm.datastore.name = ed.datastoresInfo[0].name;
                dm.datastore.id = ed.datastores[0];
            }

            if (ed.folderInfo) {
                dm.folder.name = ed.folderInfo.name;
                dm.folder.id = ed.folder;
            }
            dm.vCId = this.editData.vCenterInstanceUuid
            this.selectedVc = this.editData.vCenterInstanceUuid;
            this.dialogAction = 'Edit';
        }
        this.setGlobalDCCheck();
    }

    onCancel() {
        this.onSelectEntityClosed();
        this.isDialogOpen = false;
        this.cancelEventEmitter.emit();
    }

    saveDeploymentContainer() {
        let data = this.dataModel;
        let payload = {
            "name": data.deploymentContainerName,
            "isGlobal": data.isGlobal,
            "vCenterInstanceUuid": data.vCId,
            "resourcePools": [data.resourcePool.id],
            "datastores":[data.datastore.id]
         }

        if (data.folder.id) {
            payload["folder"] = data.folder.id;
        }
        if (this.isEdit) {
            payload['id'] = data.id;
            this.updateDeploymentContainer(payload, data.id);
        } else {
            this.addDeploymentContainer(payload);
        }
    }

    addDeploymentContainer(payload) {
        this.isEditInProgress = true;
        this.service.addDeploymentContainer(payload).subscribe(
            () => {
                this.isEditInProgress = false;
                this.isReadOnly = true;
                this.isLoading = false;
                this.closeSelf();
            },
            error => {
                this.isEditInProgress = false;
                this.isLoading = false;
                console.log('failed to add Deployment Container', error);
                this.alert.danger([this.getErrorMessage(error)], 'alertDC');

            }
        );
    }

    updateDeploymentContainer(payload, id) {
        this.isEditInProgress = true;
        this.isLoading = true;
        this.service.updateDeploymentContainer(payload, id).subscribe(
            () => {
                this.isEditInProgress = false;
                this.isReadOnly = true;
                this.isLoading = false;
                this.closeSelf();
            },
            error => {
                this.isEditInProgress = false;
                this.isLoading = false;
                console.log('failed to update Deployment Container', error);
                this.alert.danger([this.getErrorMessage(error)], 'alertDC');

            }
        );
    }

    getErrorMessage(error) {
        if (error && error.message) {
            return error.message;
        }
        return 'Error';
    }

    showEntitySelectionDialog(entityType: string) {
        this.entityType = entityType;
        if (!this.dataModel.vCId) {
            return;
        }
        if (typeof this.dataModel[entityType] !== 'undefined') {
            this.nodeToBeSelectedOnLoad = this.dataModel[entityType]['id'];
        }

        this.onSelectEntityClosed();

        if (entityType === 'resourcePool') {
            this.isRPDialogVisible = true;
        }
        if (entityType === 'datastore') {
            this.isDSDialogVisible = true;
        }
        if (entityType === 'folder'){
            this.isFolderDialogVisible = true;
        }
    }

    onSelectEntityClosed() {
        this.isRPDialogVisible = false;
        this.isDSDialogVisible = false;
        this.isFolderDialogVisible = false;
   }

   onSelectEntitySave(event) {
        this.onSelectEntityClosed();
        this.isEntityDialogVisible = false;
        if (!event || !event.entityType) {
            return;
        }
        let entityType = event.entityType;

        let entity;
        if (typeof this.dataModel[entityType] !== 'undefined') {
            this.dataModel[entityType]['id'] = event.data.id
            this.dataModel[entityType]['name'] = event.data.name
        }

   }

   onVcSelect(event) {
    let dm = this.dataModel;
    if (event && event !== 'select') {
        dm.vCId = event;
        dm.resourcePool.name = '';
        dm.resourcePool.id = '';
        dm.datastore.name = '';
        dm.datastore.id = '';
        dm.folder.name = '';
        dm.folder.id = '';
        this.setGlobalDCCheck();
    }else {
        dm.vCId = '';
        this.disableGlobal = true;
        this.dataModel.isGlobal = false;
    }

   }

   isFormValid() {
       let dm = this.dataModel;
       if (dm.deploymentContainerName && dm.vCId && dm.datastore.id && dm.resourcePool.id) {
           return true;
       }
       return false;
   }

   closeSelf() {
        this.onSelectEntityClosed();
        this.isDialogOpen = false;
        if (this.saveEventEmitter) {
             this.saveEventEmitter.emit();
          }
    }
    removeEntity(entityType: string) {
        if (entityType === 'resourcePool') {
            this.dataModel.resourcePool.id = '';
            this.dataModel.resourcePool.name = '';
        }
        if (entityType === 'datastore') {
            this.dataModel.datastore.id = '';
            this.dataModel.datastore.name = '';
        }
        if (entityType === 'folder') {
            this.dataModel.folder.id = '';
            this.dataModel.folder.name = '';
        }
    }

    setGlobalDCCheck() {
        // Create more than one Global DeploymentContainer from the same VC
        if ( this.globalDeploymentContainerVc == '' || (this.dataModel.vCId == this.globalDeploymentContainerVc) ) {
            this.disableGlobal = !(this.dataModel.vCId && this.dataModel.vCId != '');
            this.dataModel.isGlobal = (this.isEdit && this.editData.isGlobal && this.editData.isGlobal === true);
        } else {
            this.disableGlobal = true;
            this.dataModel.isGlobal = false;
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dialog/add-edit-dc.component.ts